export default "__VITE_ASSET__VR1051Wy__"